import { LoadVehicleByVin } from "./load/LoadVehicleByVin";
import { SearchVehicleByVinDataProvider } from "./SearchVehicleByVinDataProvider";
import SearchByLaximoVinContainer from "./components/SearchByLaximoVinContainer";
import { LoadVehicleByCarNumber } from "./load/LoadVehicleByCarNumber";
import { LoadingHandler } from "./load/LoadingHandler.tsx";
import { SetSearchParams } from "./load/SetSearchParams";
import { LoadVehicleByParams } from "./load/LoadVehicleByParams";

/**
 * Страница поиска автомобиля по VIN или номеру кузова
 * @returns {JSX.Element}
 */
export const SearchVehicleByVinPage = () => {
    return (
        <SearchVehicleByVinDataProvider>
            <SetSearchParams>
                <LoadVehicleByVin>
                    <LoadVehicleByCarNumber>
                        <LoadVehicleByParams>
                            <LoadingHandler>
                                <SearchByLaximoVinContainer />
                            </LoadingHandler>
                        </LoadVehicleByParams>
                    </LoadVehicleByCarNumber>
                </LoadVehicleByVin>
            </SetSearchParams>
        </SearchVehicleByVinDataProvider>
    );
};
